export const CIP_STATUS = {
  SUCCESS: 'SUCCESS',
  FAILURE: 'FAILURE',
  ABORTED: 'ABORTED',
}

export const CIP_STATUS_CODES = {
  VERIFIED: 'VERIFIED',
  MANUAL_REVIEW: 'MANUAL_REVIEW',
  REJECTED: 'REJECTED',
}

export function isCIPVerified(status, statusCode) {
  return status === CIP_STATUS.SUCCESS && statusCode === CIP_STATUS_CODES.VERIFIED
}

export function isCIPAborted(status) {
  return status === CIP_STATUS.ABORTED
}

export function isCIPInManualReview(status, statusCode) {
  return status === CIP_STATUS.SUCCESS && statusCode === CIP_STATUS_CODES.MANUAL_REVIEW
}

export function isCIPRejected(status, statusCode) {
  return status === CIP_STATUS.FAILURE && statusCode === CIP_STATUS_CODES.REJECTED
}

export function isCIPFailure(status) {
  return status === CIP_STATUS.FAILURE
}
